import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function PaymentErrorView() {
	const navigate = useNavigate();

	function handleRetry() {
		navigate('/plans');
	}

	return (
		<Container fluid className="min-vh-100 d-flex align-items-center justify-content-center">
			<Row className="w-100 justify-content-center">
				<Col lg={6} md={8} sm={10}>
					<Card className="p-4 shadow-lg text-center bg-dark text-light border-danger">
						<Card.Body>
							<h3 className="mb-4" style={{ color: '#ff6666' }}>
								Payment Failed
							</h3>
							<p className="text-light mb-4">
								Something went wrong while processing your payment. Your card has not been charged.
							</p>
							<Button variant="danger" className="me-3" onClick={handleRetry}>
								Try Again
							</Button>
							<Button variant="secondary" onClick={() => navigate('/')}>
								Return Home
							</Button>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	);
}

export default PaymentErrorView;
